import { render, staticRenderFns } from "./ot-project-user-layout.vue?vue&type=template&id=5a7e99fe&scoped=true&"
import script from "./ot-project-user-layout.vue?vue&type=script&lang=ts&"
export * from "./ot-project-user-layout.vue?vue&type=script&lang=ts&"
import style0 from "./ot-project-user-layout.vue?vue&type=style&index=0&id=5a7e99fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7e99fe",
  null
  
)

export default component.exports